import { render, staticRenderFns } from "./agentView.vue?vue&type=template&id=013a9819&scoped=true&"
import script from "./agentView.vue?vue&type=script&lang=js&"
export * from "./agentView.vue?vue&type=script&lang=js&"
import style0 from "./agentView.vue?vue&type=style&index=0&lang=less&"
import style1 from "./agentView.vue?vue&type=style&index=1&id=013a9819&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013a9819",
  null
  
)

export default component.exports